let UUID = require("uuidjs");

export const uuid = () => {
  return UUID.generate().replace("-", "");
}



// WEBPACK FOOTER //
// ./src/js/utils/uuid.js